import React, { useState } from 'react'

const UseViewHide = () => {

    const [View, setView] = useState(false)

    const handleSideBarView = (e) => {
        e.preventDefault();
        setView(!View)
    }

    return [handleSideBarView, View]
}

export default UseViewHide
